import React from 'react';

const CirclePlusIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_2235_11348)">
      <path
        d="M8 1.5C6.71443 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM2.5 8C2.50166 6.54182 3.08165 5.14383 4.11274 4.11274C5.14383 3.08165 6.54182 2.50165 8 2.5V13.5C6.54182 13.4983 5.14383 12.9184 4.11274 11.8873C3.08165 10.8562 2.50166 9.45818 2.5 8Z"
        fill="#3F3C43"
      />
    </g>
    <defs>
      <clipPath id="clip0_2235_11348">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CirclePlusIcon;
